import { post, get } from '@/utils/http';

const BASE_URL = window.location.hostname === 'localhost' ? '/api' : process.env.VUE_APP_API_BASE_URL_AI;

export function getCharacterList(data = {}) {
  return get(`${BASE_URL}/characters`, data);
}

export function getCharacterById(id) {
  return get(`${BASE_URL}/characters/${id}`);
}

export function createSession(id) {
  return post(`${BASE_URL}/characters/${id}/sessions`, {
    character_id: Number(id),
  }, {
    // headers: {
    // 'Content-Type': 'application/json',
    // },
  });
}

export function sendMessage(id, message) {
  return post(`${BASE_URL}/sessions/${id}/messages`, { message });
}

export function getSelfies(id) {
  return get(`${BASE_URL}/selfies/unlocked`, {
    character_id: Number(id),
  });
}
export function unlockSelfies(id) {
  return post(`${BASE_URL}/selfies/unlock`, {
    selfie_id: Number(id),
  }, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export function getLockedSelfies(sessionId) {
  return post(`${BASE_URL}/sessions/${sessionId}/selfies/locked`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

//  获取用户已解锁的视频列表
export function getVideos(id) {
  return get(`${BASE_URL}/selfie-videos/unlocked`, {
    character_id: Number(id),
  });
}

// 解锁视频
export function unlockVideos(id) {
  return post(`${BASE_URL}/selfie-videos/unlock`, {
    video_id: Number(id),
  }, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

// 获取会话中未解锁的视频
export function getLockedVideos(sessionId) {
  return post(`${BASE_URL}/sessions/${sessionId}/selfie-video/locked`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
}
